import { useIntl } from "react-intl";
import { StackedBarChart } from "../../../common/charts";
import CircularLoader from "../../../common/circularLoader";

const LearningItemSummary = ({ data, loading = false }) => {
  const intl = useIntl();
  const documentStyle = getComputedStyle(document.documentElement);

  const labels = data.map(
    (item) => item.name.substring(0, 15) + (item.name.length > 14 ? "..." : "")
  );
  const datasets = [
    {
      label: intl.formatMessage({ id: "overdue" }),
      data: data.map(
        (item) => item.status.find((x) => x.status === "OverDue")?.count || 0
      ),
      type: "bar",
      backgroundColor: documentStyle.getPropertyValue("--red-500"),
    },
    {
      label: intl.formatMessage({ id: "completed" }),
      data: data.map(
        (item) => item.status.find((x) => x.status === "Completed")?.count || 0
      ),
      type: "bar",
      backgroundColor: documentStyle.getPropertyValue("--green-500"),
    },
    {
      label: intl.formatMessage({ id: "notstarted" }),
      data: data.map(
        (item) => item.status.find((x) => x.status === "NotStarted")?.count || 0
      ),
      type: "bar",
      backgroundColor: documentStyle.getPropertyValue("--orange-500"),
    },
    {
      label: intl.formatMessage({ id: "inprogress" }),
      data: data.map(
        (item) =>
          item.status.find((x) => x.status === "InComplete")?.count ||
          0 + item.status.find((x) => x.status === "Started")?.count ||
          0
      ),
      type: "bar",
      backgroundColor: "#0EA5E9",
    },
  ];

  return (
    (!loading && (
      <StackedBarChart
        id="learning_item_summary"
        canDownload
        data={{
          labels: labels,
          datasets: datasets,
        }}
      />
    )) || <CircularLoader size={230} />
  );
};

export default LearningItemSummary;
